import React from 'react'
import './ButtonTableWrapper.css'

const ButtonTableWrapper = ({ children }) => <div className="ButtonTableWrapper">{children}</div>

export default ButtonTableWrapper
